"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      marginRight: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      marginRight: 0,
      marginLeft: 0,
      '& span': {
        fontSize: 14
      }
    })
  };
}, {
  name: 'CatalogueProductListOnlyStockCheckbox'
});

function CatalogueProductListOnlyStockCheckbox(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      onChange = _ref.onChange,
      value = _ref.value,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "onChange", "value"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var handleChange = _react.default.useCallback(function () {
    if (onChange) {
      onChange(!value);
    }
  }, [onChange, value]);

  return /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      checked: value,
      onChange: handleChange,
      name: 'onlyStock',
      color: "primary"
    }),
    label: t('productListOrderSelectorButton/onlyStock')
  }));
}

process.env.NODE_ENV !== "production" ? CatalogueProductListOnlyStockCheckbox.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  onChange: _propTypes.default.func,
  value: _propTypes.default.bool
} : void 0;
CatalogueProductListOnlyStockCheckbox.defaultProps = {
  classes: undefined,
  className: undefined,
  onChange: undefined,
  value: undefined
};
var _default = CatalogueProductListOnlyStockCheckbox;
exports.default = _default;